import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import API from "../../../services";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faCopy } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BONUS_API from "../../../services/bonus";
import { useTranslation } from "../../../hooks/useTranslation";

interface TransactionHistoryItemProps { }


const TransactionHistoryDetails: React.FC<TransactionHistoryItemProps> = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [newTicket, setNewTicket] = useState<any>(false);
    const [loading, setLoading] = useState(false);
    const [newTicDes, setNewTicDes] = useState<any>("");
    const [newReferenceID, setNewReferenceID] = useState<any>("");
    const [newTicCat, setNewTicCat] = useState<any>("");
    const { details, previous, status } = location.state || {};
    const navigate = useNavigate();
    const [openCancel, setOpenCancel] = useState<any>(false)
    const [remark, setRemark] = useState<any>("");
    const [selectedImages, setSelectedImages] = useState<File[]>([]);
    const [previews, setPreviews] = useState<string[]>([]);
    const [loadSubmit, setLoadSubmit] = useState<any>(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [policyData, setPolicyData] = useState<any>([]);
    const [redeemLoading, setRedeemLoading] = useState<boolean>(false);

    const categoryMap: Record<string, string> = {
        ALL: t("common.all"),
        DEPOSIT_BONUS: t("bonus.depositBonus"),
        LOSSBACK_BONUS: t("bonus.lossbackBonus"),
    };


    const dateFormat = (time: number) => {
        const matchStartTime = new Date(time);
        const formattedStartTime = matchStartTime.toLocaleString("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        });
        return { formatted: formattedStartTime };
    };


    useEffect(() => {
        if (details?.status === "SUCCESS") {
            getEligibleBonuses();
        }
    }, [details?.status]);

    const getEligibleBonuses = async () => {
        // if (loading) return;
        // setLoading(true);
        let response: any;
        try {
            const params = {
                user_key: sessionStorage.getItem("userKey"),
                deposit_transaction_id: details?.referenceId,
                category: "DEPOSIT_BONUS",
                type: "INSTANT",
                code: ""
            };
            response = await BONUS_API.post(`/bonus-policies/eligible`,
                params);

            setPolicyData(response?.data?.policies);

        } catch (e: any) {
            toast.error(e?.response?.data?.message);
            setLoading(false);
            return;
        }
        // setLoading(false);

    };





    const handleTicketsuccess = () => {
        navigate("/ticket-details", { state: { ticketId: details?.ticketId } });
    };

    useEffect(() => {
        setNewTicCat(details?.transactionType)
    }, []);


    const handleBackClick = () => {
        if (previous && previous == "bonus") {
            navigate("/wallet", { state: { tab: "bonus", status: status } });
        } else {
            navigate("/wallet", { state: { wallettab: "history" } });
        }
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!e.target.files || e.target.files.length === 0) {
            console.log("No files selected"); // Debugging
            return;
        }

        const files = Array.from(e.target.files);

        const validFiles = files.filter(file => file.size < 1024 * 1024); // Ensure size < 1MB
        if (validFiles.length === 0) {
            toast.info(t("support.messages.onlyImagesLessThan1MBAllowed"));
            return;
        }

        setSelectedImages((prevImages) => [...prevImages, ...validFiles]);
        setPreviews((prevPreviews) => [
            ...prevPreviews,
            ...validFiles.map((file) => URL.createObjectURL(file)),
        ]);

        // Fix: Reinitialize file input to ensure event triggers on next selection
        resetFileInput();
    };

    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            const newInput = fileInputRef.current.cloneNode(true) as HTMLInputElement;
            fileInputRef.current.replaceWith(newInput);
            fileInputRef.current = newInput;

            // Fix: Wrap handleImageChange inside an event listener conversion
            fileInputRef.current.addEventListener("change", (evt) => {
                handleImageChange(evt as unknown as React.ChangeEvent<HTMLInputElement>);
            });
        }
    };

    const removeImage = (index: number) => {
        setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    };

    const handleWithDrawSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setLoadSubmit(true);

        const fileToBase64 = (file: File): Promise<string> => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const result = reader.result as string;
                    const base64 = result.includes(",") ? result.split(",")[1] : result;
                    resolve(base64);
                };
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(file);
            });
        };

        try {
            const images = await Promise.all(selectedImages.map((image) => fileToBase64(image)));
            const image_names = selectedImages.map((image) => image.name);
            const image_types = selectedImages.map((image) => image.type);

            const payload = {
                category: details?.transactionType,
                description: newTicDes,
                referenceID: details?.referenceId
            };

            const formData = new FormData();
            formData.append("ticketData", JSON.stringify(payload));

            if (images.length > 0) {
                formData.append("image", images.join(","));
                formData.append("image_names", image_names.join(","));
                formData.append("image_types", image_types.join(","));
            }

            const response = await API.post(`/webapp/create-support-ticket`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            const data = response.data;
            if (data?.status !== "RS_OK") {
                toast.error(`${data.errorDescription}`);
                return;
            } else {
                toast.success(t("support.messages.ticketUpdatedSuccessfully"));
                navigate("/customersupport");
            }
            setNewTicDes("");
            setNewTicket(false);

        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            setLoadSubmit(false);
        }
    };

    if (!details) {
        return <div>{t("transactions.messages.noDetailsAvailable")}</div>;
    }

    const handleSubmit = async () => {
        setLoading(true);

        try {
            const response = await API.post(`/account/cancel-withdrawal`, {
                referenceId: details?.referenceId,
                remark: remark,
            });

            const data = await response.data;
            if (data?.status !== "RS_OK") {
                toast.error(data?.errorDescription);
            } else {
                toast.success(t("transactions.messages.success"));
                handleBackClick();
            }

            setOpenCancel(false);
        } catch (error) {
            console.log("There was a problem with the fetch operation.");
        } finally {
            setLoading(false);
        }
    };

    const handleClaim = async (policy: any) => {
        if (redeemLoading) return;
        setRedeemLoading(true);
        let response: any;
        try {
            const params = {
                user_key: sessionStorage.getItem("userKey"),
                deposit_transaction_id: details?.referenceId,
            };
            response = await BONUS_API.post(`/bonus-policies/${policy?.id}/claim`, params);
        } catch (e: any) {
            toast.error(e?.response?.data?.message);
            setRedeemLoading(false);
            return;
        }
        setRedeemLoading(false);
        if (response?.status == 204) {
            toast.success(t("transactions.messages.youHaveSuccessfullyClaimedYourBonus"));
            navigate("/wallet", { state: { tId: "", tab: "bonus" } });
        } else {
            toast.error(response?.data?.message);
        }
    };

    return (
        <>
            <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] transaction-history">
                <header className="relative flex justify-between items-center text-base font-medium text-white mb-[0.5rem] w-full">
                    <div className="flex items-center">
                        <div>
                            <div className="bg-inputbox-color flex p-1 mr-[0.5rem] rounded"
                                onClick={() => handleBackClick()}
                            >
                                <ArrowBackIcon
                                    className="text-border-color aspect-square w-[18px]"
                                    style={{ width: '20px', height: '20px' }}
                                />
                            </div>
                        </div>
                        <h2 className="">{t("transactions.transactionDetails")}</h2>
                    </div>
                    {
                        (details?.transactionType === "WITHDRAWAL" || details?.transactionType === "CRYPTO_WITHDRAWAL") && details?.status === "PENDING" && (
                            <button
                                onClick={() => setOpenCancel(true)}
                                className="p-2 text-xs text-white bg-border-color rounded-lg border border-border-color border-solid"
                            >
                                <span>{t("common.cancel")}</span>
                            </button>
                        )
                    }
                    {
                        details?.ticketId !== "" ? (
                            <button
                                onClick={() => handleTicketsuccess()}
                                className="px-3 py-2 text-xs font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-slate-800"
                            >
                                <span>{t("support.viewTicket")}</span>
                            </button>
                        ) : (
                            <button
                                onClick={() => setNewTicket(true)}
                                className="px-3 py-2 text-xs font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-slate-800"
                            >
                                <span>{t("support.newTicket")}</span>
                            </button>
                        )
                    }
                </header>
                <div className="relative">
                    {
                        details?.transactionType === "DEPOSIT" && details?.status === "SUCCESS" && (
                            <>
                                {policyData?.length > 0 ? (
                                    <div className="flex overflow-x-auto gap-4 px-2 hide-scrollbar">
                                        {policyData.map((row: any, index: any) => (
                                            <div
                                                key={index}
                                                className="bonus-card flex-shrink-0 flex flex-col gap-2 px-4 py-2 rounded-lg bg-meitms-color min-w-[70%] max-w-[80%]"
                                            >
                                                <div className="flex justify-between items-center text-white">
                                                    <div>
                                                        <div className="mt-1">{row?.name}</div>
                                                    </div>
                                                    <button
                                                        className="status bg-border-color text-white px-3 py-1 rounded cursor-pointer"
                                                        onClick={() => handleClaim(row)}
                                                    >
                                                        {t("bonus.claim")}
                                                    </button>
                                                </div>
                                                <div className="expiry text-sm text-gray-400 truncate max-w-full">
                                                    {row?.description}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center text-gray-400 pt-4">{t("transactions.noEligibleBonuses")}</div>
                                )}

                                {redeemLoading && (
                                    <div className="fixed inset-0 loading-spinner flex items-center justify-center py-4">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                                    </div>
                                )}
                            </>
                        )
                    }
                </div>

                {
                    details?.transactionType === "DEPOSIT" && details?.status === "SUCCESS" && (
                        <div className="border-b border-dashed border-border-color w-full my-4"></div>
                    )
                }

                <div className="p-2">
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("transactions.referenceId")}</p>
                        <div className="p-1 flex items-center space-x-2">
                            <p className="text-sm text-white">{details?.referenceId}</p>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(details?.referenceId || "");
                                    // alert("Reference ID copied to clipboard!");
                                }}
                                className="px-2 py-1 text-xs text-white bg-primary-color rounded hover:bg-primary-dark transition flex items-center space-x-1"
                            >
                                <FontAwesomeIcon icon={faCopy} className="text-white" />

                            </button>
                        </div>
                    </div>
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("transactions.transactionType")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.transactionType}</p>
                        </div>
                    </div>

                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("common.amount")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.amount}</p>
                        </div>
                    </div>
                    {(details?.transactionType === "CRYPTO_WITHDRAWAL" || details?.transactionType === "CRYPTO_DEPOSIT") && (
                        <>
                            <div className="mb-2">
                                <p className="text-base font-medium text-white">{t("transactions.cryptoAmount")}</p>
                                <div className="p-1">
                                    <p className="text-sm text-white">{details?.cryptoAmount}</p>
                                </div>
                            </div>
                            <div className="mb-2">
                                <p className="text-base font-medium text-white">{t("common.currency")}</p>
                                <div className="p-1">
                                    <p className="text-sm text-white">{details?.currency}</p>
                                </div>
                            </div>
                        </>
                    )}
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("transactions.status")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.status}</p>
                        </div>
                    </div>

                    {details?.transactionMethod && details.transactionMethod !== "N/A" && (
                        <div className="mb-2">
                            <p className="text-base font-medium text-white">{t("transactions.transactionMethod")}</p>
                            <div className="p-1">
                                <p className="text-sm text-white">{details.transactionMethod}</p>
                            </div>
                        </div>
                    )}
                    {details?.utr && details.utr !== "N/A" && (
                        <div className="mb-2">
                            <p className="text-base font-medium text-white">{t("transactions.utr")}</p>
                            <div className="p-1">
                                <p className="text-sm text-white">{details?.utr}</p>
                            </div>
                        </div>
                    )}
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("transactions.time")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{dateFormat(details?.time)?.formatted}</p>
                        </div>
                    </div>
                    {details?.remark && (
                        <div className="mb-2">
                            <p className="text-base font-medium text-white">{t("transactions.remark")}</p>
                            <div className="p-1">
                                <p className="text-sm text-white">{details?.remark}</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {
                newTicket && (
                    <Dialog
                        fullScreen={false}
                        open={newTicket}
                        onClose={() => setNewTicket(false)}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: '5rem'
                            }
                        }}
                    >
                        <div className="h-dialog-bg bg-inputbox-color relative p-4">
                            <CloseIcon
                                className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                onClick={() => setNewTicket(false)}
                            />
                            <div>
                                <div>
                                    {t("support.createNewTicket")}
                                </div>
                                <div>
                                    <>
                                        <form className="flex flex-col w-full" onSubmit={handleWithDrawSubmit}>
                                            <label
                                                htmlFor="amount"
                                                className="block mt-2 text-sm text-zinc-400"
                                            >
                                                {t("support.description")}
                                            </label>
                                            <input
                                                type="text"
                                                className="px-4 py-3 mt-2.5 w-full text-sm font-medium text-white placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem]"
                                                placeholder={t("support.enterYourIssue")}
                                                value={newTicDes || ""}
                                                onChange={(e) => setNewTicDes(e.target.value)}
                                            />

                                            <div>
                                                <label className="block mt-3 text-sm text-zinc-400">{t("support.attachImage")}</label>
                                                <label className="block w-full mt-2 mb-2">
                                                    <input
                                                        id="file-upload"
                                                        ref={fileInputRef}
                                                        type="file"
                                                        accept="image/*"
                                                        // multiple
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => fileInputRef.current?.click()}
                                                        className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color shadow-sm hover:bg-opacity-80"
                                                    >
                                                        {t("support.chooseImage")}
                                                    </button>
                                                </label>
                                                <label className="block text-xs text-zinc-400">{t("support.onlyImagesLessThan1MB")}</label>
                                                <label className="block text-xs text-zinc-400">{t("support.noteIfUnableToUpload")}</label>

                                                {previews.length > 0 && (
                                                    <div className="grid grid-cols-3 gap-4 mt-2">
                                                        {previews.map((preview, index) => (
                                                            <div key={index} className="relative group">
                                                                <img
                                                                    src={preview}
                                                                    alt={`Preview ${index}`}
                                                                    className="w-24 h-24 object-cover rounded-lg border border-border-color shadow-md"
                                                                />
                                                                <button
                                                                    onClick={() => removeImage(index)}
                                                                    className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center opacity-90 hover:opacity-100 transition"
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex justify-between mt-4">
                                                <button
                                                    type="submit"
                                                    className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                                                    disabled={!newTicDes || loadSubmit}
                                                >
                                                    {loadSubmit ? t("support.submitting") : t("common.submit")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                                                    onClick={() => { setNewTicket(false) }}
                                                >
                                                    {t("common.cancel")}
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                )
            }

            {
                openCancel && (
                    <Dialog
                        fullScreen={false}
                        open={openCancel}
                        onClose={() => setOpenCancel(false)}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: '5rem'
                            }
                        }}
                    >
                        <div className="dialog-bg bg-inputbox-color relative p-4">
                            <CloseIcon
                                className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                onClick={() => setOpenCancel(false)}
                            />
                            <div>
                                <div>
                                    {t("transactions.withdrawalCancellation")}
                                </div>
                                <div>
                                    <>
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleSubmit();
                                            }}
                                            className="mt-4 w-full max-w-md mx-auto"
                                        >
                                            <div className="mt-3">
                                                <label htmlFor="utrInput" className="block mt-3 text-sm text-zinc-400">
                                                    {t("transactions.areYouSureYouWantToCancelWithdrawal")}
                                                </label>
                                            </div>
                                            <div className="w-full mb-4">
                                                <label
                                                    htmlFor="amount"
                                                    className="block mt-2 text-sm text-zinc-400"
                                                >
                                                    {t("transactions.reason")}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="px-4 py-3 mt-2.5 w-full text-sm font-medium text-white placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem]"
                                                    placeholder={t("transactions.reasonForCancellation")}
                                                    value={remark || ""}
                                                    onChange={(e) => setRemark(e.target.value)}
                                                />
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    type="button"
                                                    className="p-2.5 w-full text-sm text-white whitespace-nowrap bg-red-600 rounded-lg border border-red-600 border-solid leading-[1.4rem]"
                                                    onClick={() => setOpenCancel(false)}
                                                >
                                                    {t("common.no")}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className={`p-2.5 w-full text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] ${loading || !(remark) ? "opacity-50" : ""} `}
                                                    disabled={!remark}
                                                >
                                                    <span className="submit-label">
                                                        {loading ? t("common.processing") : t("common.yes")}
                                                    </span>
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                )
            }
        </>
    );
};


export default TransactionHistoryDetails;
